<template>
    <div class="medal-detail-page" @click="pageClick">
        <!-- 背景图 -->
        <div class="medal-detail-page-bg"></div>
        <!-- top -->
        <div class="top" :style="{paddingTop: 10 + statusBarHeight + 'px'}">
            <div
                class="top-back"
            >
                <Back 
                    :clickHandle="handleClosePage"
                    :innerText="localesPackage?.['badgewall_back']?.[localesEnv]"
                />
            </div>
        </div>
        <div class="badgeView">
            <div class="badgeView-badge">
                <img :src="medalItem.badgeIcon">
                <div class="badgeView-badge-guan"></div>
                <span class="yuli-view-id"
                    v-if="medalItem?.isYuli?.id"
                    :class="{
                        'yuli-view-id-gold': medalItem?.isYuli?.role_type == 6
                    }">
                    #{{ medalItem?.isYuli?.id }}
                </span>
            </div>
            <div class="badgeView-name">
                {{ medalItem.label }}
            </div>
            <div class="badgeView-abstract">{{ medalItem.abstract }}</div>
            <div class="badgeView-time">{{ getTimeHanlde((medalItem?.time * 1000), 'YYYY-MM-DD') }}</div>
        </div>
        <div class="share-view">
            <div class="share-view-btn" @click="shareHandle">
                {{ localesPackage?.['badgewall_share']?.[localesEnv] }}
                <!-- 分享提示语 -->
                <div class="share-view-btn-tips" v-show="isShowTips" @click.stop="null">
                    {{ tipsBox[tipsMsg] }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import { getTime } from "@/utils/utils";
import { px2rem } from "@//utils/utils.js";
import Back from "@/components/universal/Back";

export default {
    components: {
        Back
    },
    props: {
        medalItem: {
            type: Object,
            default: () => {
                return null
            }
        },
        medalData: {
            type: Object,
            default: () => {
                return null
            }
        },
        newBadgeFlag: {
            default: false
        }
    },
    computed: {
        ...mapState({
            init: (state) => state.global.init,
            statusBarHeight: (state) => state.global.statusBarHeight,
            languageEnv: (state) => state.global.languageEnv,
            languagePackage: (state) => state.global.languagePackage,
        }),
    },
    watch: {
        medalData: {
            async handler(value) {
                if(value){
                    const total = value?.total || 0;
                    const newBadgeFlag = this.newBadgeFlag;
                    if(newBadgeFlag){
                        this.tipsMsg = 0;
                        // 新徽章提示
                        for(let i = 0; i < newBadgeFlag?.length; i++){
                            const currentItem = newBadgeFlag[i];
                            if(this.medalItem?.yuliId && currentItem?.yuliId){
                                if(this.medalItem.yuliId == currentItem.yuliId && this.medalItem.starId == currentItem.starId){
                                    this.isShowTips = true;
                                    break;
                                }
                            }else{
                                if(this.medalItem.starId == currentItem.starId){
                                    this.isShowTips = true;
                                    break;
                                }
                            }
                        }
                    }else{
                        const isEnterSharePage = sessionStorage.getItem('isEnterSharePage');
                        if(isEnterSharePage)return;
                        if(value?.isDone){
                            // 集齐全部
                            this.tipsMsg = 2;
                            this.isShowTips = true;
                        }else if(total == 10){
                            // 等于10触发
                            this.tipsMsg = 1;
                            this.isShowTips = true;
                        }else {
                            // 都不符合隐藏提示
                            this.isShowTips = false;
                        }
                    }
                }
            },
            immediate: true,
            deep: true,
        },
        languageEnv: {
            async handler(value) {
                if(value){
                this.localesEnv = value;
                }
            },
            immediate: true,
            deep: true,
        },
        languagePackage: {
            async handler(value) {
                if(value){
                    this.localesPackage = value;
                    const getI18nText = (key) => this.localesPackage?.[key]?.[this.localesEnv];
                    const localTextBox = [];
                    for(let i = 1; i <= 3; i++){
                        localTextBox.push(getI18nText('badgewall_share_tips' + i));
                    }
                    this.tipsBox = localTextBox;
                }
            },
            immediate: true,
            deep: true,
        }
    },
    setup(props, { emit }) {
        /**语言包 - ref */
        const localesPackage = ref({});
        /**语言环境 - ref */
        const localesEnv = ref('en');
        const isShowTips = ref(false);
        const tipsMsg = ref(null);
        const tipsBox = ref([]);
        onBeforeMount(()=>{
            // console.log(props);
        })

        const handleClosePage = () => {
            if(isShowTips.value){
                emit('handle', 'remove-red-point', props.medalItem);
            }
            emit('handle','medal-detail-close');
        }

        const pageClick = () => {
            isShowTips.value = false;
        }
        
        const shareHandle = () => {
            emit('handle', 'badgeShare');
            sessionStorage.setItem('isEnterSharePage', true);
        }

        const getTimeHanlde = getTime;

        return {
            pageClick,
            handleClosePage,
            shareHandle,
            getTimeHanlde,
            isShowTips,
            tipsMsg,
            tipsBox,
            localesPackage,
            localesEnv,
        };
    },
};
</script>
  
<style lang="less" scoped>
@topHeight: 60px;
@screenTop: 10px;
.medal-detail-page{
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: linear-gradient(180deg,
        #242321 0%,
        #393835 25%,
        #454242 50%,
        #514E4D 75%,
        #87827F 100%
    );
    z-index: 999;
    top: 0;
    left: 0;
    &-bg{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        background: url("~@/assets/images/YuliApp/badgeWall/honerPage/medal_bg.png") no-repeat
        top left;
        background-size: 100% 100%;
    }
    .top{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: @topHeight;
        &-back{
            position: absolute;
            width: 64px;
            height: 32px;
            top: 50%;
            left: 0;
            transform: translate(0,-50%);
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-right{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            &-iconView{
                width: 82px;
                height: 26px;
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                font-family: "PingFang SC";
                font-size: 12px;
                font-weight: 500;
                &-bg{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: -1;
                }
                &-icon-share{
                    width: 24px;
                    height: 24px;
                    margin-right: 2px;
                }
            }
        }
        &-tag{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(0,-50%);
            font-size: 16px;
            width: fit-content;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 10px;
            background-color: aquamarine;
            border-radius: 20px 0 0 20px;
        }
    }
    .badgeView{
        margin: 0 auto;
        margin-top: calc(@topHeight + @screenTop + 50px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: "PingFang SC";
        &-badge{
            width: 220px;
            height: 220px;
            position: relative;
            margin-bottom: 13px;
            img{
                width: 100%;
                height: 100%;
            }
            &-guan{
                width: 287px;
                height: 287px;
                position: absolute;
                background: url("~@/assets/images/YuliApp/badgeWall/honerPage/badge_bg.png") no-repeat
                top left;
                background-size: 100% 100%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: -1;
            }
        }
        &-name{
            color: #fff5d3;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 23px;
            width: 300px;
        }
        &-abstract{
            width: 280px;
            color: #ffffff;
            font-size: 16px;
            font-weight: 300;
            line-height: 19px;
            margin-bottom: 20px;
        }
        &-time{
            color: #ffb84d;
            font-size: 14px;
            font-weight: 500;
            line-height: 16.8px;
        }
    }
    .share-view{
        position: fixed;
        bottom: 80px;
        left: 50%;
        transform: translateX(-50%);
        color: #25262a;
        font-family: "PingFang SC";
        font-size: 18px;
        font-weight: 600;
        &-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 240px;
            height: 40px;
            background: url("~@/assets/images/YuliApp/badgeWall/honerPage/share_btn.png") no-repeat
            top left;
            background-size: 100% 100%;
            position: relative;
            &-tips{
                width: 182px;
                height: 72px;
                padding: 9px 4px 15px 11px;
                color: #ffffff;
                text-align: left;
                font-size: 13px;
                font-weight: 500;
                line-height: 17px;
                position: absolute;
                background: url("~@/assets/images/YuliApp/badgeWall/honerPage/share_tips_bg.png") no-repeat
                top left;
                background-size: 100% 100%;
                top: -100px;
                right: -50px;
            }
        }
    }
    .yuli-view{
        position: relative;
        &-id{
            position: absolute;
            bottom: 38px;
            right: 50%;
            transform: translate(50%, 0);
            color: #F2F2F2;
            font-size: 20px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
            text-shadow: 0 1px 2px rgba(64, 41, 17, 0.56), 1px 0 2px rgba(64, 41, 17, 0.56), -1px 0 2px rgba(64, 41, 17, 0.56), 0 -1px 2px rgba(64, 41, 17, 0.56);
            &-gold{
                color: #fffde7;
            }
        }
        img{
            width: 160px;
            height: 160px;
        }
    }
}
</style>